export default __webpack_public_path__ + "static/media/OEKOTEX 12.HIN.04547 2024 2025.034f2cba.png";